import { useAuthContext } from '@asgardeo/auth-react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useState } from 'react';

const CreditContext = createContext();
export const useCredit = () => useContext(CreditContext);

export const CreditProvider = ({ children }) => {
  const { state, getBasicUserInfo } = useAuthContext();

  const [userId, setUserId] = useState(null);  // NEW: Add userId state
  const [balance, setBalance] = useState(null);
  const [firstName, setFirstName] = useState('');
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [subid, setSubid] = useState('');

  useEffect(() => {
    const fetchCredit = async () => {
      try {
        const userInfo = await getBasicUserInfo();
        const userEmail = userInfo?.email || '';
        const subid = userInfo?.sub || '';
        const givenName = userInfo?.givenName || userInfo?.given_name || '';
        const familyName = userInfo?.familyName || userInfo?.family_name || '';
        const full = [givenName, familyName].filter(Boolean).join(' ');

        // Store basic user info
        setFirstName(givenName);
        setFullName(full);
        setEmail(userEmail);
        setSubid(subid);

        if (!userEmail) return;

        // Create/get user and store user_id
        const createResponse = await axios.post(
          `${process.env.REACT_APP_DB_SERVER_URL}/credit/create`,
          { email: userEmail, subid: subid }
        );

        // NEW: Store user_id for efficient queries
        const userId = createResponse.data.user_id;
        setUserId(userId);
        sessionStorage.setItem('user_id', userId); // Store in sessionStorage

        // Use user_id for balance query (efficient)
        const balanceResponse = await axios.get(
          `${process.env.REACT_APP_DB_SERVER_URL}/credit/balance`,
          {
            params: { user_id: userId }  // Changed from subid to user_id
          }
        );

        setBalance(balanceResponse.data.balance_credit);

      } catch (err) {
        console.error('Failed to fetch credit balance:', err);
      }
    };

    if (state?.isAuthenticated) {
      fetchCredit();
    }
  }, [state?.isAuthenticated]);

  return (
    <CreditContext.Provider
      value={{ userId, balance, email, firstName, fullName, subid }}
    >
      {children}
    </CreditContext.Provider>
  );
};

CreditProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
